

export class VehcileCategoryDto {
    id: number
    vehicleCategory: string;
    isActive: boolean;
    createdUser: string | null;
    updatedUser: string | null;
    versionFlag: number;
    constructor(
        id: number,
        vehicleCategory: string,
        isActive: boolean,
        createdUser: string | null,
        updatedUser: string | null,
        versionFlag: number,
    ) {
        this.id = id;
        this.vehicleCategory = vehicleCategory;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }




}